// extracted by mini-css-extract-plugin
module.exports = {"layout":"da51a739f7--layout--tMgCM"};